/* eslint-disable mui-unused-classes/unused-classes */
import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import { FONT_SIZES } from '@/theme'
import { allowedPositions, allowedSizes } from '@/modules/base/components/texts/config'

const useStyles = makeStyles(theme => ({
  label: { display: 'block', color: theme.textMuted },
  extrasmall: { fontSize: FONT_SIZES.extrasmall },
  small: { fontSize: FONT_SIZES.smaller },
  medium: { fontSize: FONT_SIZES.default },
  large: { fontSize: FONT_SIZES.smedium },
  left: { textAlign: 'left' },
  center: { textAlign: 'center' },
  right: { textAlign: 'right' },
  uppercase: { textTransform: 'uppercase' },
}))

const Label = (props) => {
  const {
    size = undefined,
    position = undefined,
    uppercase = false,
    children = null,
    className = '',
  } = props
  const classes = useStyles()

  return (
    <div className={clsx(classes.label, classes[size], classes[position], uppercase && classes.uppercase, className)}>{children}</div>
  )
}

Label.propTypes = {
  size: PropTypes.oneOf(allowedSizes),
  position: PropTypes.oneOf(allowedPositions),
  className: PropTypes.string,
  uppercase: PropTypes.bool,
  children: PropTypes.node,
}

Label.defaultProps = {
  size: 'small',
  position: 'left',
  className: '',
  uppercase: false,
}

export default Label
